namespace advisorop.components.servicer {

    export class OutsideHoldingsListNewController {

        //input params
        accountId: number;
        enableRtg: boolean;
        onHoldingsRtgChanged: any;
        gridDisabled: number;
        hasRtgHoldings: boolean = false;
        iAmReady: any;
        readyDone: boolean = false;
        account: domains.IAccount;

        holdings: any[];
        dg: DevExpress.ui.dxDataGridOptions;
        allocationRule: any = { type: "range", min: 0, max: 1, message: "Please enter value between 0 (0.00%) and 1 (100.00%)" };
        dgComponent: DevExpress.ui.dxDataGrid;
        assetClassnColIds: string[] = [];
        afSecurityAllocationPlan: domains.IAFSecurityAllocationPlan;
        assetClassnClassns: domains.IAFAssetClassnClassn[] = [];
        dgRowsForSaving = [];
        saveInProgress = false;
        private refreshEventUnsubscribe: () => void;

        static $inject = ["advisorService", "accountApi", "$rootScope"];
        constructor(private advisorService: services.AdvisorService, private accountApi: services.AccountApi, private $rootScope: ng.IRootScopeService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Holdings"
                },
                bindingOptions: {
                    dataSource: "vm.holdings",
                    "columns[3].allowEditing": "vm.enableRtg"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                height: "250px",
                paging: { pageSize: 200 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                editing: {
                    mode: "batch",
                    allowUpdating: true,
                    allowAdding: true,
                    allowDeleting: true
                },
                columns: [
                    { dataField: "id", caption: "Id", allowEditing: false, allowFiltering: false, visible: false },
                    { dataField: "description", caption: "Holding", allowEditing: true },
                    {
                        dataField: "amount", caption: "Value", allowFiltering: false,
                        dataType: "number",
                        format: { type: "fixedPoint", precision: 2 },
                        allowEditing: true
                    },
                    { dataField: "includeInRTG", dataType: "boolean", caption: "Include in RTG", allowEditing: true, visible: this.enableRtg },
                ],
                // highlight the contents of the cell when the user clicks on it
                // this makes it easier to change the allocation (no backspace necessary)
                onEditorPreparing: (e) => {
                    if (e.dataField === "amount" && e.parentType === "dataRow") {
                        // Intercept paste to warn about non-numeric characters (e.g. "$5000")
                        const defaultOnInitialized = e.editorOptions.onInitialized;
                        e.editorOptions.onInitialized = (args) => {
                            const inputEl = args.element.find("input");
                            inputEl.on("paste", function (event) {
                                const clipboardData = (event.originalEvent as ClipboardEvent).clipboardData;
                                if (clipboardData) {
                                    const pastedText = clipboardData.getData("text");
                                    if (pastedText && /[^\d.\-\s]/.test(pastedText)) {
                                        toastr.info("Non-numeric characters were removed. Please enter values without currency symbols (e.g. 5000, not $5000).");
                                    }
                                }
                            });
                            if (defaultOnInitialized) defaultOnInitialized(args);
                        };
                    }
                    if (this.assetClassnColIds.findIndex(i => i == e.dataField) > -1
                        && e.parentType == "dataRow") {
                        e.editorOptions.onFocusIn = function (args) {
                            args.element.find("input").select();
                        }
                    }
                },
                onInitNewRow: (e) => {
                    e.data.includeInRTG = true;
                },
                onInitialized: (e) => {
                    this.dgComponent = e.component;
                    this.updateEditingState();
                },
                onCellPrepared: (e: any) => {
                    if (this.assetClassnColIds.findIndex(i => i == e.dataField) > -1
                        && e.rowType == "data" && e.column.allowEditing) {
                        if (!e.data.includeInRTG) {
                            e.cellElement.html("");
                        }
                    }
                },
                onRowRemoving: (e: any) => {
                    if (e.key && e.key.id && e.key.id > 0) {
                        this.advisorService.deleteOutsideHoldings(e.data.id)
                            .then(response => {},
                            err => {
                                toastr.error("Error when deleting holdings. ERROR " + err.status + " " + err.data);
                                e.isValid = false;
                                e.errorText = "Error when deleting holdings. ERROR " + err.status + " " + err.data;
                                e.cancel = true;
                            });
                    }
                },
                onRowInserting: (e) => {
                    // at this point all changed rows are valid and ready to be saved
                    // but this method will fire for each changed row and we need to ensure that we call it only once
                    this.saveBatch(e.component);
                },
                onRowUpdating: (e) => {
                    // at this point all changed rows are valid and ready to be saved
                    // but this method will fire for each changed row and we need to ensure that we call it only once
                    this.saveBatch(e.component);
                },
                onRowValidating: (e: any) => {
                    // console.log('Row validating: ',e);
                    // properties which are not changed will not be in newData record so we must take them from oldData
                    e.newData.accountId = this.accountId;
                    if (e.key && e.key.id) { e.newData.id = e.key.id; } else { e.newData.id = 0; }
                    if (e.oldData) {
                        if (e.newData.description == undefined) e.newData.description = e.oldData.description;
                        if (e.newData.amount == undefined) e.newData.amount = e.oldData.amount;
                        if (e.newData.includeInRTG == undefined) e.newData.includeInRTG = e.oldData.includeInRTG;
                    }

                    if (!e.oldData) e.oldData = {};

                    if (this.account.accountType == domains.InvestmentType.DIRECT_INVESTMENT &&
                        (!e.newData.includeInRTG || (e.newData.includeInRTG == undefined && !e.oldData.includeInRTG))) {
                        e.isValid = false;
                        e.errorText = "Include in RTG must be checked because this is a Direct Account";
                        return false;
                    }

                    if (e.newData.includeInRTG || (e.newData.includeInRTG == undefined && e.oldData.includeInRTG)) {
                        var assetClassAllocations: domains.AFAssetClassClassnsAlloc[] = []
                        var totalAllocation = 0;
                        this.assetClassnColIds.forEach(c => {
                            const alloc = (e.newData[c] || e.newData[c] === 0) ? e.newData[c] : ((e.oldData[c] || e.newData[c] === 0) ? e.oldData[c] : 0)
                            totalAllocation += alloc * 100;
                            const aca: domains.AFAssetClassClassnsAlloc = {
                                afAssetClassnClassnId: parseInt(c.substring(2)),
                                allocationPercentage: alloc
                            }
                            assetClassAllocations.push(aca);
                        });
                        e.isValid = totalAllocation === 100;
                        if (!e.isValid) {
                            e.errorText = "Total allocation needs to be 100%. Current allocation is " + totalAllocation + "%";
                            toastr.error(e.errorText);
                            return false;
                        }
                    }

                    const allocations = [];
                    this.assetClassnColIds.forEach(c => {
                        e.newData[c] = 1 * this.getCurrentCellValue(e.newData[c], e.oldData[c]);
                        allocations.push({
                            outsideInvestmentHoldingId: e.newData.id,
                            aFSecurityAllocationPlanId: this.afSecurityAllocationPlan.id,
                            aFAssetClassnClassnId: parseInt(c.substring(2)),
                            allocation: e.newData[c],
                        });
                        e.newData.allocations = allocations;
                    });

                    this.dgRowsForSaving.push(e.newData);
                }
            }
        };

        onChangeHoldingsMaintainedExSystem(): void {
            this.setUpAssetAllocationColumns();
        };

        private updateEditingState(): void {
            const disableEditing = !!this.gridDisabled;
            const currentEditing = this.dgComponent ? this.dgComponent.option("editing") : this.dg.editing;
            const newEditing = Object.assign({}, currentEditing, {
                allowUpdating: !disableEditing,
                allowAdding: !disableEditing,
                allowDeleting: !disableEditing
            });

            if (this.dgComponent) {
                console.log('[OutsideHoldingsListNew] updateEditingState -> applying to component, disableEditing:', disableEditing);
                this.dgComponent.option("editing", newEditing);
            } else {
                console.log('[OutsideHoldingsListNew] updateEditingState -> setting config before init, disableEditing:', disableEditing);
                this.dg.editing = newEditing;
            }
        }

        saveBatch = (dg: DevExpress.ui.dxDataGrid) => {
            if (!this.saveInProgress) {
                this.saveInProgress = true;

                if (this.dgRowsForSaving.length <= 0) {
                    return;
                }

                dg.beginCustomLoading(`Saving data, please wait...`);

                this.advisorService.saveOutsideHoldings(this.dgRowsForSaving)
                    .then(response => {
                        toastr.success("Data has been successfully saved");
                        dg.endCustomLoading();
                        this.loadHoldings();
                    }, err => {
                        dg.endCustomLoading();
                        let errorMsg = "Unexpected error occurred.";
                        if (err && err.data) {
                            if (typeof err.data === "string") {
                                errorMsg = err.data;
                            } else if (err.data.message) {
                                errorMsg = err.data.message;
                            } else if (err.data.title) {
                                errorMsg = err.data.title;
                            }
                        } else if (err && err.statusText) {
                            errorMsg = err.statusText;
                        }
                        toastr.error(errorMsg);
                    }).finally(() => {
                        this.dgRowsForSaving = [];
                        this.saveInProgress = false;
                    });
            }
        }

        getCurrentCellValue(original: any, alternative: any): number {
            //console.log("ORIGINAL", original);
            //console.log("ALTERNATIVE", alternative);

            if (original == undefined)
                return alternative ? alternative : 0.0;
            else
                return original ? original : 0.0;
        }

        setUpAssetAllocationColumns(): void {
            // Delete previous asset class columns if any exist
            this.assetClassnColIds.forEach(i => this.dgComponent.deleteColumn(i));
            this.assetClassnColIds = [];

            // Denormalize the allocations so that they can be displayed in the grid horizontally
            if (this.assetClassnClassns && this.assetClassnClassns.length > 0) {
                this.assetClassnClassns.forEach(c => {
                    const col = "AC" + c.id.toString();
                    this.assetClassnColIds.push(col)
                    this.holdings.forEach(a => {
                        // A holding with no allocations at all must not take the columns down with
                        // it - this loop runs before addColumn, so one bad row would leave the grid
                        // with no asset-class columns to edit.
                        const allocs = a.allocations || [];
                        const ind = allocs.findIndex(aca => aca.afAssetClassnClassnId == c.id);
                        a[col] = ind > -1 ? allocs[ind].allocation : 0;
                    });
                    this.dgComponent.addColumn(
                        {
                            dataField: col, caption: c.name,
                            format: { precision: 2, type: "percent" },
                            allowEditing: true, validationRules: [this.allocationRule],
                            minWidth: 45
                        }
                    );
                });
            }
        }

        loadHoldings(): void {
            if (this.accountId > 0 || this.gridDisabled == 1) {
                this.readyDone = false;

                this.accountApi.getById(this.accountId)
                    .success((data) => {
                        this.account = data;
                    })
                    .error((data, status) => {
                        toastr.error("Error loading account " + status + " " + data);
                    });

                this.advisorService.getOutsideHoldingsAndClassns(this.accountId)
                    .then(response => {
                        this.holdings = response.data.item1;
                        this.afSecurityAllocationPlan = response.data.item2;
                        this.assetClassnClassns = response.data.item3;
                        this.hasRtgHoldings = this.holdings.map(f => f.includeInRTG).indexOf(true) >= 0;
                        this.onHoldingsRtgChanged({ hasRtgHoldings: this.hasRtgHoldings });
                        this.setUpAssetAllocationColumns();
                        if (this.iAmReady && !this.readyDone) {
                            this.readyDone = true;
                            this.iAmReady({ ctrl: this });
                        }
                    },
                        err => toastr.error("Error when trying to load holdings. ERROR " + err.status + " " + err.data)
                    );
            } else {
                this.holdings = [];
            }
        };
        
        $onInit(): void {
            console.log('[OutsideHoldingsListNew] $onInit called, accountId:', this.accountId);
            this.updateEditingState();
            
            // Listen for refresh event from account-summary (when manual account is closed)
            this.refreshEventUnsubscribe = this.$rootScope.$on('outsideHoldingsRefresh', (event: ng.IAngularEvent, data: { accountId: number }) => {
                console.log('[OutsideHoldingsListNew] Received outsideHoldingsRefresh event, data:', data, 'myAccountId:', this.accountId);
                if (data.accountId === this.accountId) {
                    console.log('[OutsideHoldingsListNew] AccountId matches, refreshing holdings...');
                    this.loadHoldings();
                } else {
                    console.log('[OutsideHoldingsListNew] AccountId does not match, ignoring event');
                }
            });
        }

        $onDestroy(): void {
            console.log('[OutsideHoldingsListNew] $onDestroy called, unsubscribing from event');
            if (this.refreshEventUnsubscribe) {
                this.refreshEventUnsubscribe();
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {        
                if ((key == "accountId" && this.accountId > 0) || (key == "gridDisabled" && this.gridDisabled == 1)) {
                    this.loadHoldings();
                }   
            }
            if (evt && evt.gridDisabled) {
                this.updateEditingState();
            }
        }
        
    }
    
    class OutsideHoldingsListNew implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                enableRtg: "<",
                gridDisabled: "<",
                onHoldingsRtgChanged: "&",
                iAmReady: "&"
            };
            this.controller = OutsideHoldingsListNewController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/outside-holdings-list.html";
        }
    }
    angular.module(Constants.APP).component("outsideHoldingsListNew", new OutsideHoldingsListNew());

}